import { MachineGuards } from 'common/bento/types/MachineConfig';
import canEditPersonalInformation from 'features/Onboarding/lib/canEditPersonalInformation';

import { Model } from './model';

export enum Guard {
  CannotEditPersonalAddress = 'cannotEditPersonalAddress',
}

const guards: MachineGuards<Model, Guard> = {
  cannotEditPersonalAddress: ({ getModuleData }) => {
    const { companyUser, companyUsers, isNewOnboardingAllowed } =
      getModuleData().personalAddressData.viewer;

    const canEditInformation = canEditPersonalInformation({
      companyUser: companyUser ?? null,
      companyUsers: companyUsers ?? null,
      isNewOnboardingAllowed,
    });

    return !canEditInformation;
  },
};

export default guards;
